import { get } from 'lodash/fp';

import { createHandler } from '@mews/std';

import { DirectionDependentAttributes, VirtualDirection } from './types';

export const getDefaultItemSize = createHandler({
    [VirtualDirection.Horizontal]: get('defaultItemWidth'),
    [VirtualDirection.Vertical]: get('defaultItemHeight'),
});

export const getDirectionDependentAttributes = createHandler<VirtualDirection, DirectionDependentAttributes>({
    [VirtualDirection.Horizontal]: {
        dimension: 'width',
        scrollDirection: 'scrollLeft',
    },
    [VirtualDirection.Vertical]: {
        dimension: 'height',
        scrollDirection: 'scrollTop',
    },
});

export const overflowHandler = createHandler({
    [VirtualDirection.Horizontal]: 'overflow-y: hidden',
    [VirtualDirection.Vertical]: 'overflow-x: hidden',
});

export const sizerStyleHandler = createHandler<VirtualDirection, (scrollableSize: number) => string>({
    [VirtualDirection.Horizontal]: (scrollableSize) => `
        height: 1px;
        width: ${scrollableSize}px;
    `,
    [VirtualDirection.Vertical]: (scrollableSize) => `
        height: ${scrollableSize}px;
        width: 1px;
    `,
});
